import { EpicRefined } from 'interfaces/middleware'
import { mergeMap, map } from 'rxjs/operators'
import { of } from 'rxjs'
import { GET_ADVISOR_MEETINGS_INFO_URL } from 'interfaces/ajax'
import { filterRequest } from 'rxOperators/filterRequestOfType'
import { GetMeetingsInfoAction, AdvisorPageActions } from 'components/features/coaching/advisorStore/actions/advisorPageActions'
import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'


export const getMeetingsInfoEpic: EpicRefined<AdvisorPageActions | AjaxCatchExtraActions> = (action$, _, { get }) => action$.pipe(
  filterRequest(GetMeetingsInfoAction.type),
  mergeMap((action) => get(GET_ADVISOR_MEETINGS_INFO_URL).pipe(
    map(({ response }) => action.success(response)),
    ajaxCatch((error) => of(action.fail({ errorCode: error.status }))),
  )),
)
